import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
var _hoisted_1 = {
  class: "footer-left"
};
var _hoisted_2 = {
  class: "footer-right"
};
import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import ExcelError from './error.vue';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'error-dialog',
  props: {
    title: {
      default: '导入失败'
    },
    width: {
      default: '30%'
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    exportBaseUrl: {
      default: ''
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var DOWNLOAD = global.globalVal[GLOBAL_DATA.FILE_DOWNLOAD];
    var props = __props;
    var importResult = ref({});
    var downloading = ref(false);
    var diaVisible = ref(false);
    function show(result) {
      importResult.value = result;
      diaVisible.value = true;
    }
    function close() {
      diaVisible.value = false;
    }
    function handleDownloadError() {
      if (downloading.value) {
        return;
      }
      downloading.value = true;
      DOWNLOAD("".concat(props.exportBaseUrl, "/excel/").concat(encodeURIComponent(importResult.value.errorExcel)), {}).finally(function () {
        downloading.value = false;
      });
    }
    __expose({
      show: show
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        ref: "dialog",
        title: _ctx.title,
        width: _ctx.width,
        "append-to-body": _ctx.appendToBody,
        modelValue: _unref(diaVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(diaVisible) ? diaVisible.value = $event : null;
        })
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_unref(importResult).errorExcel ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            type: "danger",
            plain: "",
            round: "",
            loading: _unref(downloading),
            onClick: handleDownloadError
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("下载错误文件 ")]);
            }),
            _: 1
          }, 8, ["loading"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: close
          }, {
            default: _withCtx(function () {
              return _cache[2] || (_cache[2] = [_createTextVNode("确定")]);
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createVNode(ExcelError, {
            errors: _unref(importResult).sheetImportResults
          }, null, 8, ["errors"])];
        }),
        _: 1
      }, 8, ["title", "width", "append-to-body", "modelValue"]);
    };
  }
});